import { useTranslation } from 'react-i18next';
import { Linkedin } from 'lucide-react';
import { BRAND } from '@/config/brand';
import { formatMarketingFigures } from '@/config/marketing';
import { SocialTemplate } from './SocialTemplate';

const LOGO_URL = 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/4a1265ef2_r.png';

/** LinkedIn cover, 1584 × 396 (4:1). Its figures come from config/marketing. */
export default function LinkedInHeader() {
  const { t, i18n } = useTranslation(['admin']);
  const figures = formatMarketingFigures(i18n.language);
  return (
    <SocialTemplate icon={Linkedin} title={t('admin:social.linkedinHeader.title')} width={1584} height={396} filename="linkedin-header-1584x396" gradient="from-blue-500/25 to-cyan-500/25">
      <div className="absolute inset-0 bg-gradient-to-r from-[#111] via-[#0d0d0d] to-[#121212]" />
      <div className="absolute -left-20 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-purple-600/20 blur-[120px]" />
      <div className="absolute left-10 top-1/2 h-40 w-40 -translate-y-1/2 rounded-full bg-fuchsia-500/20 blur-3xl" />
      <div className="absolute left-0 top-0 flex w-1/2 items-start p-6 sm:p-8">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt={BRAND.name} crossOrigin="anonymous" className="h-10 w-auto" />
          <div className="text-sm text-white/70">{BRAND.name}</div>
        </div>
      </div>
      <div className="absolute inset-y-0 right-0 flex w-1/2 items-center p-6 sm:p-10">
        <div className="ml-auto max-w-[90%] text-right">
          <div className="mb-2 text-xs uppercase tracking-[0.2em] text-purple-400">{t('admin:social.linkedinHeader.category')}</div>
          <p className="text-2xl font-bold leading-tight text-white sm:text-3xl">
            {t('admin:social.linkedinHeader.headline')}
            <span className="block font-normal text-white/70">{t('admin:social.linkedinHeader.subheadline')}</span>
          </p>
          <p className="mt-2 text-sm text-white/60">
            {t('admin:social.linkedinHeader.stats', { meetings: figures.meetings, satisfaction: figures.satisfaction })}
          </p>
        </div>
      </div>
    </SocialTemplate>
  );
}
